import { get } from 'lodash'
import { t } from 'localization'

const TP = 'checkout.utils.timeout'

/**
 * Checks if error is a session timeout error
 * @param error object from GraphQL
 */
export const isTimeoutError = error => {
  if (error && error.message && error.message.indexOf('401: Unauthorized') > -1) {
    return error.graphQLErrors.some(graphQLError => {
      return (
        get(graphQLError, 'extensions.response.body.error') ===
        'Your session expired. Please sign in again to continue.'
      )
    })
  }
  return false
}

/**
 * The backend uses a default error message from a library for authentication:
 * "Your session expired. Please sign in again to continue."
 *
 * This message is used to override the default since it does not make sense to
 * "sign in again" when checking out as a guest user.
 */
export const timeoutMessage = () => t(`${TP}.timeoutMessage`, 'Your session expired.')
